import moment from "moment";
import { Table } from "reactstrap";
import { isUrdu } from "../../../../constants/const";
import { GetLanguageString, NoResult } from "../../../helper/Components";
import { GetSelectedLanguage } from "../../../helper/Method";

const formatDate = (value) => {
  if (!value) return "-";
  const parsed = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"], true);
  return parsed.isValid() ? parsed.format("DD/MM/YYYY") : value;
};

const formatAmount = (value) =>
  new Intl.NumberFormat().format(Number(value) || 0);

const urClass = (value) => (isUrdu(value) ? "ur" : "");

const headerStyle = {
  background: "linear-gradient(180deg, #f7fafc 0%, #eef3f7 100%)",
  color: "#2D4455",
  fontWeight: 700,
  fontSize: "12px",
  letterSpacing: "0.2px",
  borderBottom: "2px solid #d7e2ea",
  whiteSpace: "nowrap",
  position: "sticky",
  top: 0,
  zIndex: 1,
};

const ExpenseReportTable = ({ transactions }) => {
  if (!transactions || transactions.length === 0) {
    return <NoResult />;
  }

  const headerUrClass = GetSelectedLanguage() === "ur" ? "ur" : "";
  const totalAmount = transactions.reduce(
    (sum, row) => sum + (Number(row.amount) || 0),
    0
  );

  return (
    <div
      style={{
        border: "1px solid #e4edf3",
        borderRadius: "12px",
        overflow: "auto",
        boxShadow: "0 4px 16px rgba(45, 68, 85, 0.06)",
      }}
    >
      <Table responsive className="mb-0" style={{ marginBottom: 0 }}>
        <thead>
          <tr>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="expense_report_sr_no" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="funds_date" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="expense_report_receipt_no" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="expense_report_category" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="expense_report_account" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="expense_report_item" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="expense_report_bank_account" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="funds_add_fund_amount" />
            </th>
            <th className={`text-center ${headerUrClass}`} style={headerStyle}>
              <GetLanguageString props="transactions_memo" />
            </th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((row, index) => (
            <tr
              key={`${row.transactionNo}-${row.srNo}-${index}`}
              style={{
                background: index % 2 === 0 ? "#ffffff" : "#f8fbfd",
                borderBottom: "1px solid #eef3f7",
              }}
            >
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                {row.srNo}
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                {formatDate(row.date)}
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                {row.receiptNumber || "-"}
              </td>
              <td
                className={`text-center ${urClass(row.category)}`}
                style={{ verticalAlign: "middle" }}
              >
                {row.category || "-"}
              </td>
              <td
                className={`text-center ${urClass(row.account)}`}
                style={{ verticalAlign: "middle" }}
              >
                {row.account || "-"}
              </td>
              <td
                className={`text-center ${urClass(row.item)}`}
                style={{ verticalAlign: "middle" }}
              >
                {row.item || "-"}
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                <span
                  className={urClass(row.bankAccount)}
                  style={{
                    display: "inline-block",
                    background:
                      row.accountTypeCode === "amanat_account"
                        ? "rgba(53, 160, 142, 0.12)"
                        : "rgba(72, 106, 132, 0.12)",
                    color:
                      row.accountTypeCode === "amanat_account"
                        ? "#1B6258"
                        : "#2D4455",
                    borderRadius: "999px",
                    padding: "2px 10px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  {row.bankAccount || "-"}
                </span>
              </td>
              <td className="text-center" style={{ verticalAlign: "middle" }}>
                <strong style={{ color: "#1B6258", fontSize: "13px" }}>
                  {formatAmount(row.amount)}
                </strong>
              </td>
              <td
                className={urClass(row.memo)}
                style={{ verticalAlign: "middle" }}
              >
                {row.memo || "-"}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr
            style={{
              background: "#eef3f7",
              borderTop: "2px solid #d7e2ea",
            }}
          >
            <td
              colSpan="7"
              className={`text-right ${headerUrClass}`}
              style={{
                verticalAlign: "middle",
                fontWeight: 700,
                padding: "10px 12px",
              }}
            >
              <GetLanguageString props="expense_report_total" />
            </td>
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              <strong style={{ color: "#1B6258", fontSize: "13px" }}>
                {formatAmount(totalAmount)}
              </strong>
            </td>
            <td />
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

export default ExpenseReportTable;
